






























import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import { Routes } from '@front-app/constants/routes';
import EventCreateForm from '@front-app/modules/event/components/form/EventCreateForm.vue';
import { useAdminAccess } from '@front-app/modules/group/hooks/useAdminAccess';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { computed, defineComponent } from '@vue/composition-api';
import { Location } from 'vue-router';

export default defineComponent({
	components: {
		ColumnContainer,
		ColumnHeader,
		EventCreateForm,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const { hasEventManagementAccess } = useAdminAccess(group);
		const getEventAdminRoute = (eventId: string): Location => ({
			name: Routes.EVENT_ADMIN_DETAILS,
			params: { eventId },
			query: { isCreateSuccess: 'true' },
		});

		return {
			hasEventManagementAccess,
			getEventAdminRoute,
			GROUP_MAIN_ROUTE: Routes.GROUP_MAIN,
		};
	},
});
